<template>
  <div
    class="field RMPE-CustomField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <div class="control is-expanded">
      <label
        :for="fieldQuestionId"
        class="label m-b-none"
      >
        <span
          :class="{'RMPE-Required': question.required}"
          v-html="question.label"
        />
      </label>
      <div class="is-fullwidth">
        <VueSelect
          :id="fieldQuestionId"
          ref="auto-focus-target"
          :value="fieldValue"
          :options="options"
          :class="{ 'is-danger': fieldHasError }"
          v-bind="autocompleteConfig"
          @input="setSelected"
          @search="setShowDropdown"
          @search:blur="isBlurred = true"
        />
      </div>
    </div>
    <ErrorMessage
      v-if="fieldHasError"
      :errors="error.errors"
      :is-blurred="isBlurred"
      :manual-validate="manualValidate"
    />
    <HintMessage
      v-else
      :hint="question.warningMessage"
    />
  </div>
</template>

<script>
import StaticFieldMixin from '../../mixins/static-field-mixin';
import AutocompleteFieldMixin from '../common/autocomplete-field';

export default {
  mixins: [StaticFieldMixin, AutocompleteFieldMixin],
};
</script>

<style scoped lang="scss">
.field{
  .is-danger {
    ::v-deep .vs__dropdown-toggle {
      border-color: black !important;
    }
  }
}

.is-fullwidth{
  margin-top: 0.5em!important;
}

</style>
